var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTrainingCost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3D82F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.076,
    cy: 19.925,
    r: 12.495,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.411 26.341v-1.634h1.433v1.634zm0-11.192v-1.64h1.433v1.64zm.788 10.012q-1.027 0-1.836-.377a3.5 3.5 0 0 1-1.33-1.068 3.8 3.8 0 0 1-.672-1.648l1.42-.23q.205.893.876 1.424.672.524 1.611.524.931 0 1.515-.454.59-.454.59-1.16 0-.502-.303-.816-.294-.314-.966-.53l-2.316-.727q-2.057-.649-2.057-2.513 0-.88.412-1.53.417-.648 1.172-1.005t1.761-.356q.966.014 1.713.363.754.35 1.248 1.006.5.656.692 1.578l-1.46.265a2.2 2.2 0 0 0-.404-.95 2.1 2.1 0 0 0-.768-.642 2.34 2.34 0 0 0-1.035-.237 2.3 2.3 0 0 0-.973.174q-.425.181-.678.517a1.2 1.2 0 0 0-.247.747q0 .46.35.782.348.321 1.103.552l1.816.537q1.248.377 1.803 1.012.555.636.555 1.69 0 .921-.453 1.613-.445.684-1.254 1.075-.808.384-1.884.384",
    fill: "#3D82F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingCost);
export default __webpack_public_path__ + "static/media/TrainingCost.231e6585b7f10168d1b488dc1c31ecff.svg";
export { ForwardRef as ReactComponent };